import { DA_COMM_EMOTE } from '../types';
import { EditorState, Modifier } from 'wix-rich-content-editor-common';
/**
 * General process:
 * - Add space char at selection
 * - Mark that offset as immutable entity and append metadata
 * - Let the decorator find the entity and use metadata to render the thumb
 */ export default function addCommunityEmote(editorState, { src, width, height, url, title, type = undefined }) {
    // Create the new entity with metadata
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity(DA_COMM_EMOTE, 'IMMUTABLE', {
        type,
        src,
        width,
        height,
        url,
        title
    });
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    // Get the selection and insert space at offset
    // attaching the entity and metadata to it
    const selection = editorState.getSelection();
    let contentStateWithInsertedText = Modifier.replaceText(contentStateWithEntity, selection, ' ', undefined, entityKey);
    // Add a space so we can focus and continue typing
    contentStateWithInsertedText = Modifier.insertText(contentStateWithInsertedText, contentStateWithInsertedText.getSelectionAfter(), ' ');
    const nextEditorState = EditorState.push(editorState, contentStateWithInsertedText, 'insert-community-emote');
    return EditorState.forceSelection(nextEditorState, contentStateWithInsertedText.getSelectionAfter());
}
